module.exports = __webpack_public_path__ + "static/img/background-0309.503b62d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background-0309.jpg
// module id = pq+r
// module chunks = 1